import React from 'react';
import './UploadProgress.css';

const UploadProgress = ({ progress }) => {
    const isComplete = progress >= 100;
    const isProcessing = progress >= 95 && progress < 100;
    const radius = 80;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    // Calculate color based on percentage
    // 0% = #012928 (dark green) -> 100% = #dc6601 (orange)
    const getProgressColor = (percent) => {
        const startColor = { r: 1, g: 41, b: 40 }; // #012928
        const endColor = { r: 220, g: 102, b: 1 }; // #dc6601

        const ratio = percent / 100;
        const r = Math.round(startColor.r + (endColor.r - startColor.r) * ratio);
        const g = Math.round(startColor.g + (endColor.g - startColor.g) * ratio);
        const b = Math.round(startColor.b + (endColor.b - startColor.b) * ratio);

        return `rgb(${r}, ${g}, ${b})`;
    };

    const progressColor = getProgressColor(progress);

    // Determine progress label based on status
    const getProgressLabel = () => {
        if (isComplete) {
            return 'Upload Complete';
        } else if (isProcessing) {
            return 'Processing...';
        } else {
            return 'Uploading';
        }
    };

    return (
        <div className="upload-progress-container">
            <div className="progress-circle-wrapper">
                <svg width="220" height="220" viewBox="0 0 220 220">
                    {/* Background circle */}
                    <circle
                        cx="110"
                        cy="110"
                        r={radius}
                        fill="none"
                        stroke="#eef7f9"
                        strokeWidth="12"
                    />
                    {/* Progress circle with dynamic color */}
                    <circle
                        cx="110"
                        cy="110"
                        r={radius}
                        fill="none"
                        stroke={progressColor}
                        strokeWidth="12"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        strokeLinecap="round"
                        className={!isComplete ? 'progress-circle-animating' : 'progress-circle'}
                        transform="rotate(-90 110 110)"
                    />
                </svg>
                <div className="progress-center-text">
                    <div className="progress-percentage">{Math.round(progress)}%</div>
                    <div className="progress-label">{getProgressLabel()}</div>
                </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: '20px', color: '#666' }}>
                <small>Mohon tunggu, jangan tutup halaman ini</small>
            </div>
        </div>
    );
};

export default UploadProgress;



// WEBPACK FOOTER //
// ./src/components/UploadProgress.js